import { ReactNode } from 'react';

import { DrawerManager } from './drawer-manager.component';

const DrawerProvider = ({ children }: { children: ReactNode }) => (
  <>
    {children}
    <DrawerManager />
  </>
);

export { DrawerProvider };
